import React, { useState, createContext, useMemo, useCallback } from 'react'
import Component from './Component'
import { CollectionTheme, CollectionType } from '../../lib/types'

// @ts-ignore
export const CreateEventContext = createContext<{
  actions: {
    open: (callback: (collection: CollectionType | null) => void, title?: string, themes?: CollectionTheme[]) => void
    close: (collection?: CollectionType) => void
  }
  store: {
    reload: boolean
  }
}>({
  // @ts-ignore
  actions: {},
  store: { reload: false }
})

export const CreateEventProvider: React.FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [initialTitle, setInitialTitle] = useState<string>('')

  const [callBack, setCallBack] = useState<((collection: CollectionType | null) => void) | undefined>(undefined)
  const [reload, setReload] = useState(false)
  const [thms, setThemes] = useState<CollectionTheme[]>([])

  const open = useCallback(
    (callback: (collection: CollectionType | null) => void, title?: string, themes?: CollectionTheme[]) => {
      setReload(false)
      setIsOpen(true)
      if (title) setInitialTitle(title)
      if (themes) setThemes(themes)
      setCallBack(() => callback)
    },
    []
  )

  const close = useCallback((collection?: CollectionType) => {
    setReload(true)
    setIsOpen(false)
    setInitialTitle('')
    setCallBack((prev: ((collection: CollectionType | null) => void) | undefined) => {
      if (prev) prev(collection || null)
      return undefined
    })
  }, [])

  const value = useMemo(
    () => ({
      actions: { open, close },
      store: { reload }
    }),
    [open, close, reload]
  )

  return (
    <CreateEventContext.Provider value={value}>
      {isOpen && <Component initialTitle={initialTitle} themes={thms} />}
      {children}
    </CreateEventContext.Provider>
  )
}
